import React, { useState, useEffect } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Stack,
  Alert,
  Select,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

const AddOrgLevelTypeModal = ({
  opened,
  onClose,
  onSave,
  orgLevelTypes = [],
}) => {
  const [name, setName] = useState("");
  const [parentId, setParentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const parentOptions = orgLevelTypes
    .filter(t => !t.base_org_level_type)
    .map(t => ({ value: String(t.id), label: t.name }));

  useEffect(() => {
    if (opened) {
      setName("");
      setParentId(null);
      setError("");
    }
  }, [opened]);

  const handleSave = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await onSave({
        name: name.trim(),
        parent_org_level_type_ids: parentId ? [Number(parentId)] : [],
      });
      onClose();
    } catch (err) {
      setError(err.message || "Failed to save sales group type");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName("");
    setParentId(null);
    setError("");
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="Add Sales Group Type"
      size="md"
    >
      <Stack gap="md">
        {error && (
          <Alert
            icon={<IconAlertCircle size={16} />}
            color="red"
            variant="light"
          >
            {error}
          </Alert>
        )}

        <TextInput
          label="Name"
          placeholder="Enter sales group type name"
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />

        <Select
          label="Parent Type"
          placeholder="Select parent type"
          data={parentOptions}
          value={parentId}
          onChange={setParentId}
          searchable
          clearable
        />

        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            loading={loading}
            disabled={!name.trim()}
          >
            Add
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AddOrgLevelTypeModal;
